"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
exports.createForm = function () {
    var enhancers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        enhancers[_i] = arguments[_i];
    }
    var enhancer = redux_1.compose.apply(void 0, enhancers);
    var store = redux_1.createStore(function (state) { return state; }, enhancer);
    return store;
};
//# sourceMappingURL=createForm.js.map